import { render, staticRenderFns } from "./package-size-selector.vue?vue&type=template&id=6e9339ff"
import script from "./package-size-selector.vue?vue&type=script&lang=js"
export * from "./package-size-selector.vue?vue&type=script&lang=js"
import style0 from "./package-size-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports